var map = {
	"./berni.jpg": "8fcc",
	"./fulanito.jpg": "98b7",
	"./hugo1.jpg": "9ac3",
	"./hugo2.jpg": "4354",
	"./hugo3.jpg": "c2b1",
	"./sergio.mp4": "2252",
	"./sergio.webm": "e5cd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c38f";